import { Quote } from 'lucide-react';
import SectionHeading from '@/components/site/SectionHeading';
import Reveal from '@/components/ui/Reveal';
import { useTestimonials } from '@api/public';

export default function Testimonials({ eyebrow, title }) {
  const items = useTestimonials();
  return (
    <section className="py-16 sm:py-24">
      <div className="site-container">
        <SectionHeading eyebrow={eyebrow} title={title} />
        <div className="mt-10 grid gap-6 lg:grid-cols-2">
          {items.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <figure className="relative flex h-full flex-col rounded-3xl border border-[var(--app-border)] bg-white p-7 shadow-sm sm:p-9">
                <Quote className="h-10 w-10 text-primary-200" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 text-pretty text-lg leading-relaxed text-ink-700">“{t.quote}”</blockquote>
                <figcaption className="mt-6 flex items-center gap-4 border-t border-[var(--app-border)] pt-5">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-flame-x font-display text-xl font-bold text-white">
                    {t.name.charAt(0)}
                  </span>
                  <span>
                    <span className="block font-semibold text-ink-950">{t.name}</span>
                    <span className="block text-sm text-ink-500">
                      {[t.designation, t.company].filter(Boolean).join(', ')}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
